import { createSlice } from '@reduxjs/toolkit';
import { emit } from '../websocket/websocketSlice'

const dataCollectionSlice = createSlice({
    name: 'dataCollection',
    initialState: {
        scriptInfoList: [],
    },
    reducers: {
        setScriptInfoList: (state, action) => {
            state.scriptInfoList = action.payload;
        },
        updateScriptLog: (state, action) => {
            const { scriptAlias, logValue } = action.payload;
            const script = state.scriptInfoList.find(
                (item) => item.scriptAlias === scriptAlias
            );

            if (script) {
                if (script.logScript != logValue) {
                    script.logScript = logValue;

                    emit({
                        type: 'manageScriptInfo',
                        scriptAlias: scriptAlias,
                        logValue: logValue,
                    });
                }  
            }
        },
    },
});

export const { setScriptInfoList, updateScriptLog } = dataCollectionSlice.actions;

export const selectScriptInfoList = (state) => state.dataCollection.scriptInfoList;

export default dataCollectionSlice.reducer;